// File service for handling image uploads and conversions
class FileService {
  // Convert file to base64 data URL
  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // Compress image if needed
  async compressImage(file, maxWidth = 800, maxHeight = 600, quality = 0.8) {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Calculate new dimensions
        let { width, height } = img;
        
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Draw and compress
        ctx.drawImage(img, 0, 0, width, height);
        
        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          file.type,
          quality
        );
      };
      
      img.src = URL.createObjectURL(file);
    });
  }

  // Simulate file upload to server (in real app, this would upload to your backend/cloud storage)
  async uploadFile(file) {
    // Simulate upload delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // In a real application, you would upload to your server or cloud storage
    // and return the public URL. For demo purposes, we'll use a data URL
    const base64 = await this.fileToBase64(file);
    
    // Simulate server response
    return {
      url: base64,
      filename: file.name,
      size: file.size,
      type: file.type,
      uploadedAt: new Date().toISOString()
    };
  }

  // Generate a mock URL for uploaded files (in real app, this would be your CDN/storage URL)
  generateMockUrl(file) {
    // In production, this would return something like:
    // return `https://your-cdn.com/uploads/${Date.now()}-${file.name}`;
    
    // For demo, we'll use object URLs or base64
    return URL.createObjectURL(file);
  }

  // Validate image file
  validateImageFile(file, maxSize = 5 * 1024 * 1024) {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    
    if (!validTypes.includes(file.type)) {
      throw new Error('Please upload a PNG or JPG image file.');
    }
    
    if (file.size > maxSize) {
      throw new Error(`File size must be less than ${Math.round(maxSize / (1024 * 1024))}MB.`);
    }
    
    return true;
  }
}

export const fileService = new FileService();